module.exports = __webpack_public_path__ + "static/media/clothes.069bdaa0.svg";